// @ts-ignore
import is from '@ukpostbox/frontend-framework/lib/Components/ItemRow/ItemRow.module.scss';
import { DraggingSelectorMousePosType } from '../Types/SharedFunctions/DragAndDropTypes';

const mailItemDragImage = document.createElement('img');
mailItemDragImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
mailItemDragImage.width = 0;
mailItemDragImage.height = 0;

const GetMailEntriesInBetween = (el: any, endEl: any, forwards: boolean) => {
	const inBetween: any = [];

	inBetween.push(el.getAttribute('data-item-id'));

	if (el !== endEl) {
		GetMailEntriesInBetween(forwards ? el.nextElementSibling : el.previousElementSibling, endEl, forwards);
	}

	return inBetween;
};

const HighlightMailEntriesInBetween = (el: any, endEl: any, forwards: boolean, highlightClass: string) => {
	if (el) {
		el.classList.add(highlightClass);
		if (el !== endEl) {
			HighlightMailEntriesInBetween(
				forwards ? el.nextElementSibling : el.previousElementSibling,
				endEl,
				forwards,
				highlightClass,
			);
		}
	}
};

const SetSelectedMailItemDetails = (e: any, targetClassName: string, mailBoxInfo: any) => {
	e.dataTransfer.setData('text/html', targetClassName);
	e.dataTransfer.setData('text/plain', mailBoxInfo.customFolderId ? mailBoxInfo.customFolderId.toString() : '');
	e.dataTransfer.effectAllowed = 'none';
	e.dataTransfer.dropEffect = 'none';
	e.dataTransfer.setDragImage(mailItemDragImage, window.outerWidth, window.outerWidth);
};

const ShiftSelectorDetector = (e: any, gridViewRef: any) => {
	if (!gridViewRef.current || e.shiftKey) {
		document
			.querySelectorAll(
				`.${CSS.escape(is['item-row-selected'])}:not(.sticky):not(.item-shift-active):not(.custom-folder-list-entry)`,
			)
			.forEach((item) => item.classList.add('item-shift-active'));
	}

	if (e.type === 'keyup') {
		document
			.querySelectorAll(`.item-shift-active:not(.${CSS.escape(is['item-row-selected'])})`)
			.forEach((item) => item.classList.remove('item-shift-active'));
	}

	return e.type === 'keydown';
};

const ShiftSelectMouseOver = (e: any, selectedItemsRef: any, gridViewRef: any, lastMousePosRef: any) => {
	const startEl = document.querySelector(
		`[data-item-id="${selectedItemsRef.current[selectedItemsRef.current.length - 1]}"]`,
	);
	const endEl = document
		.elementFromPoint(e.clientX || lastMousePosRef.current.x, e.clientY || lastMousePosRef.current.y)
		?.closest('.mailbox-item');
	const parentEl = startEl?.parentElement || endEl?.parentElement;

	if (startEl !== endEl && startEl?.nextElementSibling && endEl) {
		document
			.querySelectorAll(`.item-shift-active:not(.${CSS.escape(is['item-row-selected'])})`)
			.forEach((item) => item.classList.remove('item-shift-active'));
		const startIndex = Array.prototype.indexOf.call(parentEl?.children, startEl);
		const endIndex = Array.prototype.indexOf.call(parentEl?.children, endEl);
		HighlightMailEntriesInBetween(
			startIndex > endIndex ? startEl.previousElementSibling : startEl.nextElementSibling,
			endEl,
			endIndex > startIndex,
			'item-shift-active',
		);
	}
};

const DraggingSelectorElementIntersections = (draggerRef: any) => {
	const allItems: NodeListOf<HTMLDivElement> = document.querySelectorAll(
		'.mailbox-item-block:not(.custom-folder-list-entry)',
	);

	const CheckIntersect = (topEl: HTMLDivElement, el: HTMLDivElement) => {
		if (!topEl) return false;
		const topElBounds = topEl.getBoundingClientRect();
		const elBounds = el.getBoundingClientRect();

		const x1 = topElBounds.x;
		const y1 = topElBounds.y;
		const w1 = topElBounds.width;
		const h1 = topElBounds.height;

		const b1 = Math.floor(y1 + h1);
		const r1 = Math.floor(x1 + w1);

		const x2 = elBounds.x;
		const y2 = elBounds.y;
		const w2 = elBounds.width;
		const h2 = elBounds.height;

		const b2 = Math.floor(y2 + h2);
		const r2 = Math.floor(x2 + w2);

		return !(b1 <= y2 || y1 >= b2 || r1 <= x2 || x1 >= r2);
	};

	for (let i = 0; i < allItems.length; i += 1) {
		if (draggerRef.current && CheckIntersect(draggerRef.current, allItems[i])) {
			allItems[i].classList.add('item-drag-selected');
		} else {
			allItems[i].classList.remove('item-drag-selected');
		}
	}
};

const DraggingSelectorMousePos = (props: DraggingSelectorMousePosType) => {
	const parentContainer = props.mailBoxesRef.current.getBoundingClientRect();
	const header = props.mailBoxesRef.current.querySelector('[class*="page-header"]');
	const toolbar = props.mailBoxesRef.current.querySelector('[class*="item-row-header"]');
	const reduction =
		header && toolbar ? header.getBoundingClientRect().height + toolbar.getBoundingClientRect().height : 0;

	const newX =
		props.e.pageX <= parentContainer.left
			? 0
			: props.e.pageX >= parentContainer.right
				? parentContainer.right - parentContainer.left
				: props.e.pageX - parentContainer.left;
	let newY = props.e.pageY <= 0 ? 0 : props.e.pageY > parentContainer.height ? parentContainer.height : props.e.pageY;

	newY = !props.isLarge ? newY - parentContainer.top : newY;
	newY = newY < reduction ? reduction : newY;

	props.draggerPositionCallback({
		left: `${newX > props.dragPos.current.startX ? props.dragPos.current.startX : newX}px`,
		top: `${newY < parentContainer.top ? parentContainer.top : newY > props.dragPos.current.startY ? props.dragPos.current.startY : newY}px`,
		width: `${newX > props.dragPos.current.startX ? newX - props.dragPos.current.startX : props.dragPos.current.startX - newX}px`,
		height: `${newY > props.dragPos.current.startY ? newY - props.dragPos.current.startY : props.dragPos.current.startY - newY}px`,
	});

	DraggingSelectorElementIntersections(props.draggerRef);

	if (props.e.clientY >= window.innerHeight - 5) {
		window.scroll({
			top: window.scrollY + 150,
			behavior: 'smooth',
		});
	}
	if (props.e.clientY <= 0) {
		window.scroll({
			top: window.scrollY - 150,
			behavior: 'smooth',
		});
	}
};

export {
	GetMailEntriesInBetween,
	HighlightMailEntriesInBetween,
	SetSelectedMailItemDetails,
	ShiftSelectorDetector,
	ShiftSelectMouseOver,
	DraggingSelectorElementIntersections,
	DraggingSelectorMousePos,
};
